import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import { sizeActions } from "../../../../../../actions";
import DataTable from "../../../../../common/ui/table/DataTable/DataTable.component";

const Sizes = (props) => {
  const { searchQuery } = props;
  const dispatch = useDispatch();
  const sizes = useSelector((state) => state.sizes);

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "name",
      headerName: "Name",
      minWidth: 160,
      flex: 1,
    },
    {
      field: "code",
      headerName: "Code",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 100,
      flex: 1,
      hide: true,
    },
    {
      field: "created_at",
      headerName: "Created At",
      width: 150,
      hide: true,
    },
    {
      field: "updated_at",
      headerName: "Updated At",
      width: 150,
      hide: true,
    },
  ];

  const recordIdentifier = "name";

  useEffect(() => {
    dispatch(sizeActions.getAllParameters());
  }, [dispatch]);

  return (
    <Box>
      {sizes && (
        <DataTable
          loading={sizes?.loading}
          rows={sizes?.items?.data}
          columns={columns}
          recordIdentifier={recordIdentifier}
          actionIdentifier="sizeActions"
          search ={searchQuery}
        />
      )}
    </Box>
  );
};

export default Sizes;
